import {Component} from '@angular/core';

// Providers
import {rsReportSvc, IReportDetails } from '../../../services/report.service';

interface IMapMarkers {
    size: string;
    color: string;
    label: string;
};

interface IMapOptions {
    width: number;
    height: number;
    zoom :number;
    maptype: string;
    markers: IMapMarkers; 
}

@Component({
    templateUrl: 'tab-info.html',
})
export class InfoReportTab
{
    private mapUrl : string = "";
    private report : IReportDetails = undefined;

    constructor(private reportSvc : rsReportSvc ){
        // Constructor
        console.log('report-page:info-tab constructor');

        // Store report
        this.report = this.reportSvc.getActiveReport();

        // Craete our map options structure
        let mapOptions : IMapOptions = {
            width: 320,
            height: 256,
            zoom: 15,
            maptype: 'hybrid',
            markers : {
                size: 'mid',
                color: 'blue',
                label: 'A'
            }
        }

        // Create our mapUrl 
        this.mapUrl = encodeURI('https://maps.googleapis.com/maps/api/staticmap?' +
            'center="' + this.report.project.address + ', ' + this.report.project.zipcode +
            '"&zoom=' + mapOptions.zoom +
            '&size=' + mapOptions.width + 'x' + mapOptions.height + 
            '&maptype=' + mapOptions.maptype + 
            '&markers=size:' + mapOptions.markers.size + '|color:' + mapOptions.markers.color + '|label:' + mapOptions.markers.label +
            '|' + this.report.project.address + ', ' + this.report.project.zipcode + 
            '&key=AIzaSyCeymD4mx3BUFweYzfRXwVHeGReZBtn6aY');

    }
}


// WEBPACK FOOTER //
// ./src/pages/report/tab-info/tab-info.component.ts